import '.d{display:flex;}.ssr-plugin'
import '.k{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.aq{gap:0.5rem;}.ssr-plugin'
import '.aw{cursor:pointer;}.ssr-plugin'
import '.gm{padding:0.75rem;}.ssr-plugin'
import '.ac{border-radius:1.25rem;}.ssr-plugin'
import '.ar{border:var(--border-subtle);}.ssr-plugin'
import '.ad{background-color:var(--palette-white);}.ssr-plugin'
import '.em{transition:background-color 0.2s ease;}.ssr-plugin'
import '.cl{width:2.5rem;}.ssr-plugin'
import '.cm{height:2.5rem;}.ssr-plugin'
import '.jn{color:var(--palette-blue-700);}.ssr-plugin'
import '.jo{font-size:0.9rem;}.ssr-plugin'
import '.am{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="d k e v aq aw gm ac ar ad em"
        style={{
          '&:hover': {
            backgroundColor: 'var(--palette-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="cl cm d v k jn"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="jo jn am"
        >
          {label}
        </span>
      </styled.button>
    )
}